import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import DiscussionFeed from './discussion-feed'
import {
  getFetchContributionsRequest,
  getContributionsList
} from '../../../stores/discussion/discussion.selectors'
import { fetchDiscussion } from '../../../stores/discussion/discussion.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { match }) => {
  return {
    id: match.params.assessmentFileId,
    pending: getFetchContributionsRequest(state).pending,
    contributions: getContributionsList(state) || []
  }
}

const mapDispatchToProps = dispatch => ({
  onMount: id => dispatch(fetchDiscussion(id)).catch(errorHandler)
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DiscussionFeed)
)
